import {ChangeDetectionStrategy, Component, input, output} from '@angular/core'
import {faChevronRight} from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import {PUBLIC_ROUTES} from '../../../../../shared/routing/public.routes'
import {LinkService} from '../../../../../core/i18n/link.service'
import {RegionWithExcludedIndustries, RegionalIndustry} from '../../../../../core/content/types/craftsmen-region-types'

@Component({
  selector: 'bgo-industries-and-regions',
  templateUrl: './industries-and-regions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [':host { display: block; }'],
})
export class IndustriesAndRegionsComponent {
  regions = input.required<RegionWithExcludedIndustries[] | null>()
  industries = input.required<RegionalIndustry[] | null>()
  pagination = input.required<{offset: number; size: number; total: number}>()
  pageOffsetChange = output<number>()

  protected readonly chevronRight = faChevronRight
  constructor(private readonly linkService: LinkService) {}

  getRegionPageLink(regionSlug: string) {
    return this.linkService.localizedPathTo(PUBLIC_ROUTES.CRAFTSMEN_REGION_PAGE, {
      routeParams: {regionSlug},
    })
  }

  getIndustryRegionPageLink(regionSlug: string, industrySlug: string) {
    return this.linkService.localizedPathTo(PUBLIC_ROUTES.CRAFTSMEN_REGION_INDUSTRY_PAGE, {
      routeParams: {regionSlug, industrySlug},
    })
  }

  nextPage() {
    const p = this.pagination()
    this.pageOffsetChange.emit(p.offset + p.size)
  }

  previousPage() {
    const p = this.pagination()
    this.pageOffsetChange.emit(p.offset - p.size)
  }

  goToPage(offset: number) {
    this.pageOffsetChange.emit(offset)
  }
}
